import { useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import MentionBase from './MentionBase';
import { useIsNonVisitorUser } from '../../account/useIsLoggedIn';
import { gql } from '../../graphql/generated/gql';
import { useAllGroupMap } from '../../groups/useAllGroups';
import groupIcon from '../../icons/prefilled/16x16/group.svg';
import groupPath from '../../utils/url/groupPath';
import useIsPublicView from '../../utils/useIsPublicView';

const PUBLIC_GROUP_QUERY = gql(/** @complexity 1 */ `
  query GroupMentionPublic($id: ID!) {
    group: publicGroup(id: $id) {
      id
      name
    }
  }
`);

interface GroupMentionProps {
  id: string;
  content: string | null;
  mentionText?: string | null;
  updateCache?: (name?: string) => void;
  link: boolean;
  newTab?: boolean;
  selected?: boolean;
}

const GroupMention = ({
  id,
  content,
  mentionText,
  updateCache,
  link,
  newTab,
  selected,
}: GroupMentionProps) => {
  const isNonVisitorUser = useIsNonVisitorUser();
  const isPublicView = useIsPublicView();

  const groupsMap = useAllGroupMap();
  const { data: publicData } = useQuery(PUBLIC_GROUP_QUERY, {
    variables: { id },
    skip: !isPublicView,
  });

  const group = groupsMap[id] ?? publicData?.group;

  const path = groupPath(group ?? { id, name: content ?? '' });

  useEffect(() => {
    if (!isPublicView && group?.name != null && content == null) {
      updateCache?.(group.name);
    }
  }, [updateCache, isPublicView, group?.name, content]);

  return (
    <MentionBase
      icon={groupIcon}
      type="group"
      to={link && isNonVisitorUser ? path : undefined}
      content={mentionText ?? group?.name ?? content ?? undefined}
      newTab={newTab}
      selected={selected}
    />
  );
};

export default GroupMention;
